const useModel1Authorization = (model1) => {
    const newRecord = model1.id === null || model1.id === undefined;

    return {
        edit: newRecord || Boolean(model1.authorization?.update),
        update: Boolean(model1.authorization?.update),
        delete: Boolean(model1.authorization?.delete),
        confirm: Boolean(model1.authorization?.confirm),
    }
}

export default useModel1Authorization;